export default {
    computed: {
        keywordsWidth() {
            let chinessWord = new RegExp('[\\u4E00-\\u9FFF]+');
            let number = /[0-9]/;
            let lowercase = /[a-z]/;
            let capital = /[A-Z]/;
            let widthNumber = 0;
            // 不同类型的输入字符给不同的宽度，大概数值
            this.keyword.split('').forEach(i => {
                if (chinessWord.test(i)) {
                    widthNumber += 14;
                } else if (number.test(i)) {
                    widthNumber += 8.6;
                } else if (lowercase.test(i)) {
                    widthNumber += 7.8;
                } else if (capital.test(i)) {
                    widthNumber += 9.3;
                } else {
                    widthNumber += 10;
                }
            });
            return `${widthNumber + 26}px`;
        },
        showClear() {
            let tmp = this.focused || this.hovering;
            return !this.disabled && !this.readonly && this.selectedNodes.length && tmp;
        }
    },
    methods: {
        focusInput() {
            if (this.$refs.input) {
                this.$refs.input.focus();
            }
        },
        setTreeInvisible() {
            this.treeVisible = false;
        },
        handleFocus() {
            this.focused = true;
            this.treeVisible = true;
        },
        handleBlur() {
            if (this.clearTextWhenNotMatch) {
                this.keyword = '';
            }
            this.focused = false;
            // this.treeVisible = false;
        },
        isSelectLevel(node) {
            let level = Number(node.level);
            if (!this.selectLevel) {
                // 没有selectLevel 直接通过
                return true;
            }
            if (Array.isArray(this.selectLevel)) {
                // selectLevel是数组
                return ~this.selectLevel.indexOf(level);
            }
            if (typeof this.selectLevel === 'number' || typeof this.selectLevel === 'string') {
                // selectLevel是数字 或 字符串
                return Number(this.selectLevel) === level;
            }
        },
        filterNodesBySettings(node) {
            let isSelectLevel = this.isSelectLevel(node);
            let isLeafFullFiled = this.leafOnly ? node.leaf === true : true;
            return isSelectLevel && isLeafFullFiled;
        },
        getNodesByIds(ids) {
            let r = [];
            if (!Array.isArray(ids)) return;
            for (let id of ids) {
                let t = this.data.find(i => +i[this.valueKey] === +id);
                if (t) r.push(t);
            }
            return r;
        },
        getSelectedNodesFromData(val) {
            let selectedNodes = this.getNodesByIds(val);
            // console.log('in getSelectedNodesFromData,selectedNodes =', selectedNodes)

            selectedNodes = selectedNodes.filter(this.filterNodesBySettings);
            // console.log('in getSelectedNodesFromData,selectedNodes =', selectedNodes)

            return selectedNodes;
        },
        setSelectNodes(selectedNodes) {
            // this.$nextTick(function() {
            //     // debugger;
            //     let selectedNodes = this.$refs.tree.getCheckedNodes();
            //     selectedNodes = selectedNodes.filter(node =>
            //         this.isSelectLevel(node)
            //     ); //非选择顺序
            //     this.selectedNodes = selectedNodes;
            // });

            let oldNodes = this.getOldNodes(selectedNodes, this.selectedNodes);
            let newNodes = this.getNewNodes(selectedNodes, oldNodes);
            // console.log(' this.selectedNodes =', this.selectedNodes.map(i => i.name))
            // console.log('selectedNodes =', selectedNodes.map(i => i.name))
            // console.log('oldNodes =', oldNodes.map(i => i.name))
            // console.log('newNodes =', newNodes.map(i => i.name))
            this.selectedNodes = oldNodes.concat(newNodes);
            // console.log(' in setSelectNodes, this.selectedNodes =', this.selectedNodes)
            // console.log('getCheckedNodes', this.$refs.tree.getCheckedNodes());
        },
        getOldNodes(selectedNodes, currentNodes) {
            let allIds = selectedNodes.map(i => i.id);
            return currentNodes.filter(i => allIds.includes(i.id) || allIds.includes(+i.id));
        },
        getNewNodes(selectedNodes, oldNodes) {
            let curIds = oldNodes.map(i => i.id);
            return selectedNodes.filter(i => !(curIds.includes(i.id) || curIds.includes(+i.id)));
        }
    }
};
